/* src/app/components/staff-room/staff-room.components.scss */
:host {
  flex-direction: column;
}
.second-level-menu {
  background: #fff;
  height: 100%;
  max-height: 92vh;
  width: calc(100% - 30px) !important;
  margin: 10px auto;
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
}
/*# sourceMappingURL=staff-room.components.css.map */
